import { DynamicForm } from "~root/models/dynamicForm"
import { Api } from "~utils/api"
import { Endpoints } from "~constants/endpoints"

const FormService = {
  getFormById: async (formId: string): Promise<DynamicForm> => {
    try {
      const formUrl = Endpoints.FORM.URL.replace(":formId", formId)
      const response = await Api.get(formUrl)
      return response.data
    } catch (error) {
      return Promise.reject(error)
    }
  },
}

export default FormService
